module.exports = __webpack_public_path__ + "img/TATA Consulting Services (Intern).b76702d9.png";